import { Lightning, Router } from '@lightningjs/sdk'

import Button from '../components/button/button'
import { backgroundDark, getColor, primaryText, secondaryText } from '../constants/colors'
import { HOME } from '../constants/routes'
import { getText } from '../utils/dictionary'

export default class NotFound extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: getColor(backgroundDark),
      flex: {
        direction: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
      Title: {
        text: {
          text: getText('pageNotFoundTitle'),
          textColor: getColor(primaryText),
          fontSize: 52,
          lineHeight: 52,
          wordWrapWidth: 572,
        },
      },
      Info: {
        flexItem: {
          marginBottom: 44,
        },
        text: {
          text: getText('pageNotFoundText'),
          textColor: getColor(secondaryText),
          fontSize: 38,
          textAlign: 'center',
          lineHeight: 38,
          wordWrapWidth: 1094,
        },
      },
      Button: {
        w: 192,
        type: Button,
        label: getText('okButton'),
      },
    }
  }

  get button() {
    return this.tag('Button') as Button
  }

  _getFocused() {
    return this.button
  }

  _handleEnter() {
    Router.navigate(HOME)
  }

  _handleBack() {
    Router.navigate(HOME)
  }
}
